import React, { useContext, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import { Grid, Typography, TextField, Button } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { LangContext } from "../../../Context/Langcontext";
import MapContainer from "../../../Component/Map/map";
import { sendMailContactUs } from "../../../API/ContactUs";

const useStyle = makeStyles((theme) => ({
  root: { height: "100vh", width: "100%", backgroundColor: "#fcfcfb" },
  map: { height: "50vh", width: "100%", backgroundColor: "#fcfcfb" },
  getintouch: { backgroundColor: "#fcfcfb", paddingTop: theme.spacing(3) },
  component: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  mapcomponent: {
    height: "85%",
    width: "85%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  touchcomponent: {
    height: "85%",
    width: "85%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  textfield: {
    "& .MuiOutlinedInput-input": {
      padding: "15px 14px",
    },
  },
  inputStyle: {
    fontWeight: 200,
  },
  inputLabelStyle: {
    fontWeight: 400,
    fontSize: "1rem",
    transform: "translate(14px, 16px) scale(1)",
  },
  btnstyle: {
    margin: "1rem",
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    marginTop: "2rem",
    "&:hover": {
      backgroundColor: "#E16733",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  maintext: {
    color: "#595A5A",
    fontSize: "2rem",
  },
  mapcon: { height: "42.5vh", width: "100%" },
}));

const Getintouch = () => {
  const classes = useStyle();
  const [infomail, setinfomail] = useState({ subject: '', message: '', name: '', email: '', phone: '' })
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;


  const { enqueueSnackbar } = useSnackbar();

  const onChangeInfo = (e) => {
    setinfomail({ ...infomail, [e.target.name]: e.target.value })
  }

  const sendEmail = async (e) => {
    e.preventDefault()
    const rsSendMail = await sendMailContactUs(infomail)
    if (rsSendMail.status.code === 200) {
      enqueueSnackbar(lang.sendMailSuccess, {
        variant: "success",
      });
    } else {
      enqueueSnackbar(lang.sendMailError, {
        variant: "error",
      });
    }
  }

  return (
    <div >
      <MapContainer style={classes.mapcon} />
      <Grid container className={classes.getintouch}>
        <div className={classes.component}>
          <div className={classes.touchcomponent}>
            <Typography className={classes.maintext}>
              {lang.Getintouch}
            </Typography>
            <form style={{ width: "100%", padding: "2rem" }} onSubmit={sendEmail}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    id="outlined-subject"
                    label={lang.Subject}
                    required
                    name='subject'
                    value={infomail.subject}
                    onChange={onChangeInfo}
                    variant="outlined"
                    className={classes.textfield}
                    fullWidth
                    inputProps={{
                      className: classes.inputStyle,
                    }}
                    InputLabelProps={{
                      className: classes.inputLabelStyle,
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    multiline={true}
                    rows={8}
                    id="outlined-message"
                    label={lang.Detail}
                    required
                    name='message'
                    value={infomail.message}
                    onChange={onChangeInfo}
                    variant="outlined"
                    fullWidth
                    inputProps={{
                      className: classes.inputStyle,
                    }}
                    InputLabelProps={{
                      className: classes.inputLabelStyle,
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="outlined-name"
                    label={`${lang.Name} - ${lang.Lastname}`}
                    required
                    name='name'
                    value={infomail.name}
                    onChange={onChangeInfo}
                    variant="outlined"
                    className={classes.textfield}
                    fullWidth
                    inputProps={{
                      className: classes.inputStyle,
                    }}
                    InputLabelProps={{
                      className: classes.inputLabelStyle,
                    }}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <TextField
                    id="outlined-email"
                    label={lang.Email}
                    type='email'
                    required
                    name='email'
                    value={infomail.email}
                    onChange={onChangeInfo}
                    variant="outlined"
                    className={classes.textfield}
                    fullWidth
                    inputProps={{
                      className: classes.inputStyle,
                    }}
                    InputLabelProps={{
                      className: classes.inputLabelStyle,
                    }}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <TextField
                    id="outlined-phone"
                    label={lang.Phone}
                    type='tel'
                    pattern="[0-9]{10}"
                    name='phone'
                    value={infomail.phone}
                    onChange={onChangeInfo}
                    variant="outlined"
                    fullWidth
                    className={classes.textfield}
                    inputProps={{
                      className: classes.inputStyle,
                      type: 'tel',
                      pattern: "[0-9]{10}"
                    }}
                    InputLabelProps={{
                      className: classes.inputLabelStyle,
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button className={classes.btnstyle} type='submit'>{lang.Submit}</Button>
                </Grid>
              </Grid>
            </form>
          </div>
        </div>
      </Grid>
    </div>
  );
};

export default Getintouch;
